import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useContrySelect } from '../../../hooks';
import { Country } from '../../../types';
import SimpleSelect, { SimpleSelectProps } from '../SimpleSelect';

export interface CountrySimpleSelectProps extends Omit<SimpleSelectProps, 'options' | 'value'> {
  value: string;
  propId?: keyof Country;
  allowedCountryCodes?: string[];
}

const CountrySelect = ({
  value: countryCode,
  onChange,
  propId,
  allowedCountryCodes,
  ...others
}: CountrySimpleSelectProps) => {
  const { t } = useTranslation();
  const { options, loading, disabled } = useContrySelect(allowedCountryCodes);

  const singleOptionId = useMemo(
    () => (options && options.length === 1 ? options[0].id : null),
    [options]
  );

  useEffect(() => {
    if (singleOptionId && singleOptionId !== countryCode) {
      onChange(singleOptionId);
    }
  }, [onChange, singleOptionId, countryCode]);

  return (
    <SimpleSelect
      {...others}
      label={t('toolbar.labels.country')}
      options={options}
      disabled={disabled}
      value={countryCode}
      loading={loading}
      onChange={onChange}
    />
  );
};

export default CountrySelect;
